export class CustomError extends Error {
    constructor(message: string) {
      super(message);
      this.name = 'CustomError';
    }
  }
  

export const isError = (error: unknown): error is CustomError => {
    return error instanceof CustomError;
};

